import { render, staticRenderFns } from "./infinite-list.vue?vue&type=template&id=0f279678&scoped=true"
import script from "./infinite-list.vue?vue&type=script&lang=js"
export * from "./infinite-list.vue?vue&type=script&lang=js"
import style0 from "./infinite-list.vue?vue&type=style&index=0&id=0f279678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_4rliqqz3ui7xo7iaw2ukiguuga/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f279678",
  null
  
)

export default component.exports